import React from "react";
import HeroSection from "./components/HeroSection";
import About from "./components/About";
import Navbar from "./components/Navbar";
import Services from "./components/Services";
import Reiki from "./components/Reiki";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import ContactUs from "./components/ContactUs";
import "./App.css";

function App() {
  return (
    <div className="site-shell">
      <Navbar />
      <main id="main-content">
        <HeroSection />
        <About />
        <Reiki />
        <Testimonials />
        <Services />
        <ContactUs />
      </main>
      <Footer />
    </div>
  );
}

export default App;
